// extracted by mini-css-extract-plugin
export var root = "Companies-module--root--1vGiL";
export var logo = "Companies-module--logo--2zMD4";
export var logoImage = "Companies-module--logoImage--2gbEf";